<template lang="pug">
.envelope-actions-bar(:class='{ "envelope-actions-bar--inline": inline }')
  .actions-group
    button.action-button.action-button--outline(
      @click='$emit("resend-notification")'
      type='button'
      v-if='showResendCancel && envelope.state === "in-transit" && !onlyFaceToFace'
      v-tooltip:top='resendTooltipMessage'
    )
      icon(name='share-from-square')
      span {{ $t('modal.envelope.resendNotification') }}
    button.action-button.action-button--danger(
      @click='$emit("cancel-envelope")'
      type='button'
      v-if='showResendCancel && envelopeIsPending && userView === "sender"'
    )
      icon(name='ban')
      span {{ $t('modal.envelope.cancelEnvelope') }}
    .dropdown-stylized.dropup.action-dropdown
      button.action-button.action-button--dark(
        aria-expanded='false'
        data-bs-toggle='dropdown'
        type='button'
      )
        icon(name='arrow-down-to-bracket')
        span {{ $t('modal.envelope.downloadDocuments') }}
        icon.action-chevron(name='angle-down')
      .dropdown-menu(aria-labelledby='productsDropdown')
        ul
          template(v-if='documents.length > 1')
            li
              button.dropdown-item(
                @click='$emit("download-envelope")'
                type='button'
              )
                | {{ downloadLabel }}
            li
              span(
                :title='$t("sentEnvelopesCardTable.downloadOnlyWhenEnvelopeCompleted")'
                data-placement='top'
                data-toggle='tooltip'
                tabindex='0'
              )
                button.dropdown-item(
                  :disabled='!envelopeIsCompleted'
                  @click='$emit("download-signature-page")'
                  type='button'
                ) {{ $t('modal.envelope.signaturePage') }}
            li
              span(
                :title='$t("sentEnvelopesCardTable.downloadOnlyWhenEnvelopeCompleted")'
                data-placement='top'
                data-toggle='tooltip'
                tabindex='0'
              ) 
                button.dropdown-item(
                  :disabled='!envelopeIsCompleted'
                  @click='$emit("download-completed-envelope")'
                  type='button'
                ) {{ $t('button.downloadEnvelopeCompleted') }}
          template(v-else-if='documents.length === 1')
            li
              a(
                :href='documents[0].links.download'
                download
                target='_blank'
              )
                button.dropdown-item(type='button')
                  | {{ downloadLabel }}
            li
              a(
                :href='documents[0].links.background_sheet'
                :title='$t("sentEnvelopesCardTable.downloadOnlyWhenEnvelopeCompleted")'
                data-placement='top'
                data-toggle='tooltip'
                download
                tabindex='0'
                target='_blank'
              )
                button.dropdown-item(
                  :disabled='!envelopeIsCompleted'
                  type='button'
                ) {{ $t('modal.envelope.signaturePage') }}
            li
              span(
                :title='$t("sentEnvelopesCardTable.downloadOnlyWhenEnvelopeCompleted")'
                data-placement='top'
                data-toggle='tooltip'
                tabindex='0'
              )
                button.dropdown-item(
                  :disabled='!envelopeIsCompleted'
                  @click='$emit("download-completed-envelope")'
                  type='button'
                ) {{ $t('button.downloadEnvelopeCompleted') }}
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';

export default {
  name: 'EnvelopeActionsBar',
  components: {
    Icon,
  },
  props: {
    envelope: {
      type: Object,
      required: true,
    },
    documents: {
      type: Array,
      required: true,
    },
    envelopeIsPending: {
      type: Boolean,
      default: false,
    },
    envelopeIsCompleted: {
      type: Boolean,
      default: false,
    },
    userView: {
      type: String,
      required: true,
    },
    onlyFaceToFace: {
      type: Boolean,
      default: false,
    },
    resendTooltipMessage: {
      type: String,
      default: '',
    },
    downloadLabel: {
      type: String,
      default: '',
    },
    showResendCancel: {
      type: Boolean,
      default: true,
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="stylus">
.envelope-actions-bar
  position: sticky
  bottom: 0
  z-index: 3
  display: flex
  align-items: center
  justify-content: center
  padding: 1rem 1.25rem
  background-color: #fff
  border-top: 1px solid rgba(204, 204, 204, .5)

  &--inline
    position: static
    justify-content: flex-start
    padding: 0
    background-color: transparent
    border-top: none

    .actions-group
      justify-content: flex-start

.actions-group
  display: flex
  align-items: center
  gap: 1rem
  flex-wrap: wrap
  justify-content: center

.action-button
  -webkit-appearance: none
  -moz-appearance: none
  appearance: none
  display: inline-flex
  align-items: center
  gap: 0.5rem
  padding: 0.6rem 1.25rem
  border-radius: 24px
  font-size: 0.85rem
  font-weight: 600
  border: 1px solid transparent
  cursor: pointer
  transition: opacity .15s ease
  outline: none

  &:hover
    opacity: 0.85

  &--outline
    background-color: #fff
    border-color: #007bff
    color: #007bff

  &--danger
    background-color: #dc3545
    color: #fff

  &--dark
    background-color: #013D52 !important
    background-image: none
    color: #fff !important
    .icon
      color: #fff !important
    span
      color: #fff !important

.action-chevron
  margin-left: 0.15rem

.action-dropdown
  position: relative
  .dropdown-menu
    min-width: 220px
    border-radius: 8px
    box-shadow: 0 2px 12px rgba(0, 0, 0, .12)

@media only screen and (max-width: 768px)
  .actions-group
    flex-direction: column
    align-items: stretch
    width: 100%

  .action-button
    justify-content: center
    width: 100%

    &--danger
      order: 1

    &--outline
      order: 2

  .action-dropdown
    order: 3
</style>
